import { render, staticRenderFns } from "./ZheXianTongJi.vue?vue&type=template&id=bb49ceb8&scoped=true&"
import script from "./ZheXianTongJi.vue?vue&type=script&lang=js&"
export * from "./ZheXianTongJi.vue?vue&type=script&lang=js&"
import style0 from "./ZheXianTongJi.vue?vue&type=style&index=0&id=bb49ceb8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb49ceb8",
  null
  
)

export default component.exports